import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EntityService } from 'app/shared/service/entity.service';
import { AppConfigService } from 'app/shared/service/app-config.service';
import { Observable } from 'rxjs';
import { Todo } from './todo.model';
import { StatutTodoEnum } from './statut.todo.enum';

@Injectable()
export class TodoService extends EntityService<Todo> {

    constructor(private _http: HttpClient, private _configService: AppConfigService) {
        super(_http, _configService);
    }

    getTodoByDate(body: { date: string, userIds?: number[], statut?: StatutTodoEnum[], name?: string }): Observable<any> {
        const url = `${this._configService.config.apiUrl}/todos/by-date`;
        return this._http.post<any>(url, body);
    }

    repeatTodo(body: {}): Observable<any> {
        const url = `${this._configService.config.apiUrl}/todos/repeat`;
        return this._http.post<any>(url, body);
    }

    getTodoFromToday(body: { userId: number }): Observable<any> {
        const url = `${this._configService.config.apiUrl}/todos/from-today`;
        return this._http.post<any>(url, body);
    }

    getTodoReport(body: { userId: number, startDate: string, endDate: string }): Observable<any> {
        const url = `${this._configService.config.apiUrl}/todos/report`;
        return this._http.post<any>(url, body);
    }

}


